import React from "react";
import Image from '../images/bharat araku1.png'
import { useNavigate } from 'react-router-dom';


const Navbar = () => {
  const navStyle = {
    // backgroundColor: "#FDEAE5",
    backgroundColor: "#e3edea",   // rgba(255, 248, 225, 0.7)
    padding: "20px 0 10px 0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    fontFamily:"oswald",
  };

  const logoStyle = {
    fontSize: "2rem",
    fontWeight: "bold",
    color: "#5C1D0E",
    display: "flex",
    alignItems: "center",
  };

  const navLinksContainer = {
    display: "flex",
    justifyContent: "center",
    gap: "40px",
    marginTop: "10px"
  };

  const linkStyle = {
    color: "#5C1D0E",
    textDecoration: "none",
    fontWeight: "bold",
    letterSpacing: "1px",
    fontSize: "14px",
    cursor: "pointer"
  };

  const navigate = useNavigate();
  const coffeeworld = () => {
    navigate("/CoffeeWorld")
  }
  const Origin = () => {
    navigate("/")
  }

  const contact = () => {
    navigate("/Contact")
  }

  const product = () => {
    navigate("/Product")
  }

  return (
    <>
    <div style={navStyle}>
      <div style={logoStyle}>
        {/* Replace the text with <img src="your-logo.png" /> if needed */}
        <span style={{ marginRight: "20px",}}><img style={{width:"150px", height:"70px" }} src={Image} alt="" /></span> 
        {/* <span>Bharat Araku</span> */}
      </div>
      <div style={navLinksContainer}>
        <div style={linkStyle} onClick={Origin}>THE ORIGIN</div>
        <div style={linkStyle} onClick={coffeeworld}>ITS A COFFEE WORLD</div>
        <div style={linkStyle} onClick={product}>KNOW OUR PRODUCTS</div>
        <div style={linkStyle} onClick={contact}>CONTACT US</div>
      </div>
    </div>
    </>
  );
};

export default Navbar;
